import { BaseColor } from '@prophecy/theme';
import { Badges } from '@prophecy/ui-v3';
import { pluralizeWithNumber } from '@prophecy/utils/string';

import { BranchStatus, BranchStatusItem } from './types';

const STATUS_TONE: Record<BranchStatus, `${BaseColor}`> = {
  [BranchStatus.Active]: BaseColor.success,
  [BranchStatus.Uncommitted]: BaseColor.warning
};

function getStatusLabel(status: BranchStatusItem) {
  if (status.type === BranchStatus.Uncommitted) {
    return pluralizeWithNumber(status.fileCount, 'uncommitted file');
  }
  return status.type;
}

export const BranchStatusBadge = ({ status }: { status: BranchStatusItem }) => {
  return (
    <Badges variant='pillLight' size='s' tone={STATUS_TONE[status.type]}>
      {getStatusLabel(status)}
    </Badges>
  );
};
